import { wrapArray } from '@converdy/utils'

export default function toMutation (mutationOrMutations) {
  return function ({ commit }, { payload }) {
    wrapArray(mutationOrMutations).forEach(
      mutation => commit(mutation, payload)
    )
  }
}
